/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin POST /sections — create course ({@link COURSE_CREATION_REQUESTED}).
 *
 * @file CreateCourseService.js
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  COURSE_CREATION_REQUESTED,
  COURSE_CREATION_COMPLETED,
  COURSE_CREATION_FAILED
} from '../../../common/constants';

export default class CreateCourseService extends BaseService {
  constructor() {
    super(COURSE_CREATION_REQUESTED, 'createCourseStatus');
  }

  /** POST /sections */
  handleEvent(eventName, eventData = {}) {
    const { payload } = eventData;

    return this.getClient('marin').post('/sections', payload);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { data } = response;
    const { callback } = eventData;

    Framework.getEventManager().publish(COURSE_CREATION_COMPLETED, data);

    if (typeof callback === 'function') {
      callback(data);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(COURSE_CREATION_FAILED, error);
  }
}
